import { Injectable } from '@angular/core';
import {
  Router, CanActivate,  CanActivateChild
} from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from '../shared/services/token-service';
// import { AuthService } from '../services/authservice/auth-service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  token: string;
  userId: number;
  authenticate: any;
  userType: any;
  constructor(private router: Router, private tokenService: TokenService, public toastr: ToastrService) { }
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
  canActivateChild(): boolean {
      const currentUser = this.tokenService.getToken();
      if (currentUser != null)  {
      const tokendata = currentUser.split('|');
      this.userId = tokendata[1];
      this.token = tokendata[2];
      if (this.token != null) {
        return true;
      } else {
        this.toastr.info('Token expired,please login again', 'Login');
        this.router.navigate(['/login']);
        return false;
      }

    } else {
      this.toastr.info('Token expired,please login again', 'Login');
      this.router.navigate(['/login']);
      return false;
    }
  }
}
